var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSwapSelectArrow = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22095 1.55748C9.22095 1.74848 9.14795 1.94048 9.00195 2.08648L5.53195 5.57348C5.39095 5.71448 5.19995 5.79348 4.99995 5.79348C4.80095 5.79348 4.60995 5.71448 4.46895 5.57348L0.996949 2.08648C0.704949 1.79348 0.704949 1.31948 0.998949 1.02648C1.29295 0.734482 1.76795 0.735482 2.05995 1.02848L4.99995 3.98148L7.93995 1.02848C8.23195 0.735482 8.70595 0.734482 8.99995 1.02648C9.14795 1.17248 9.22095 1.36548 9.22095 1.55748",
    fill: "#9B9FB8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwapSelectArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/swap-select-arrow.74859e8c.svg";
export { ForwardRef as ReactComponent };